/*import plugins*/
import ENDPOINTS from "@/plugins/axios/endpoints";

const dateTime = {
  namespaced: true,

  /*Start state*/
  state: {
    date: new Date().toISOString().substr(0, 10),
    time: "", //new Date().toISOString().substr(11, 5)

    openTimes: [],
    openDaysIndex: [],
    times: []
  },
  /*End state*/

  /*Start getters*/
  getters: {
    date: state => state.date,
    time: state => state.time,
    openDaysIndex: state => {
      state.openTimes.forEach(openTime => {
        state.openDaysIndex.push(openTime.day_index);
      });
      return state.openDaysIndex;
    },

    times: state => {
      var daySelect = new Date(state.date).getDay();

      state.times = [];

      Object.values(state.openTimes).forEach(openTime => {
        if (
          eval(openTime.day_index) === daySelect &&
          openTime.is_open === true
        ) {
          state.times.push(
            ...openTime.shift_1.filter(time => time.available).map(t => t.time),
            ...openTime.shift_2.filter(time => time.available).map(t => t.time)
          );
        }
      });
      return state.times.sort();
    }
  },
  /*End getters*/

  /*Start mutations*/
  mutations: {
    setOpenTimes: (state, openTimes) => {
      state.openTimes = openTimes;
    },

    addDate: (state, val) => {
      state.date = val;
    },

    addTime: (state, val) => {
      state.time = val;
    }
  },
  /*End mutations*/

  /*Start actions*/
  actions: {
    /*Start fetch opening-times*/
    async fetchOpenTimes({ commit }, payload) {
      window.store.commit("loader/changeStatus", true); //start global loading

      await window.axios
        .get(ENDPOINTS.ONLINE_SERVICES.OPENING_TIMES.GET_ALL, {
          params: payload
        })
        .then(response => {
          commit("setOpenTimes", response.data.slots_by_day);
        })
        .catch(() => {})
        .finally(function() {
          window.store.commit("loader/changeStatus", false); //stop global loading
        });
    }
    /*End fetch opening-times*/
  }
  /*End actions*/
};

export default dateTime;
